'use strict';

var _ = require('lodash');
var MarketAnalysisToolbarController = function MarketAnalysisToolbarController($scope, $rootScope, searchCriteriaConstantsService, dataService, dataRetrieverService, currentStateCriteriaService, scenarioService, featureToggleService, dataRetrieverConstantsService, applicableSeasonsLoadingService) {
  $scope.screen = searchCriteriaConstantsService.MARKET_ANALYSIS;
  $scope.cogOptionsSet = _.clone(require('../config/cogOptionsSet.json'));
  $scope.demandPostingPanel = {
    visible: false
  };
  $scope.demandTransparencyPanel = {
    visible: false
  };
  $scope.switchDemandTypeMode = function (demandTypeMode) {
    dataRetrieverService.setDataFlow(demandTypeMode, dataRetrieverConstantsService.MARKET_SCREEN, dataRetrieverConstantsService.MARKET_MODE);
  };
  if (featureToggleService.isEnabled('MAPPED_MODE')) {
    $scope.switchDemandTypeMode('REGULAR');
    $scope.searchModes = [{
      label: 'Regular',
      mode: 'REGULAR'
    }, {
      label: 'Mapped',
      mode: 'MAPPED'
    }];
  } else {
    $scope.switchDemandTypeMode('MAPPED');
  }
  $scope.$on('scenarios:load', function () {
    $scope.loadingScenariosInProgress = true;
  });
  $scope.$on('scenarios:loaded', function () {
    $scope.loadingScenariosInProgress = false;
  });
  $scope.$on('search-criteria:forceSearch', function (evt, scenario) {
    $scope.forcedSearch = true;
    $scope.$broadcast('scenarios:force-select', scenario);
  });
  $scope.$on('market-analysis-toggle:toggleMode', function (event, mode) {
    $scope.saveIconVisible = mode !== 'market';
  });
  $scope.$on('demand-posting:swap', function ($event, isShown, contextData) {
    $scope.demandPostingPanel.contextData = contextData;
    $scope.demandPostingPanel.visible = isShown;
    $rootScope.$broadcast('workflow-tab-changed', 'demand-posting', isShown);
  });
  $scope.$on('demand-transparency:swap', function ($event, isShown, contextData) {
    $scope.demandTransparencyPanel.contextData = contextData;
    $scope.demandTransparencyPanel.visible = isShown;
    $rootScope.$broadcast('workflow-tab-changed', 'demand-transparency', isShown);
  });
  $scope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    var transitionScreenState = _.get(toParams, ['transitionData', 'screenState']);
    if (transitionScreenState) {
      $scope.cogOptionsSet.defaults['no-submenu']['no-group'] = [transitionScreenState.dataDimension];
    }
  });
  $scope.simpleViewMode = function () {
    return $scope.demandPostingPanel.visible || $scope.demandTransparencyPanel.visible;
  };
  $scope.triggerSearch = function () {
    applicableSeasonsLoadingService.resetSeasons();
    dataService.clearCache();
    if (!$scope.forcedSearch) {
      $scope.$broadcast('scenarios:reset');
    }
    $scope.$broadcast('search-criteria:searchChangeEvent');
    $rootScope.$broadcast('market-mode-search-criteria:searchChangeEvent');
  };
};
MarketAnalysisToolbarController.$inject = ['$scope', '$rootScope', 'SearchCriteriaConstantsService', 'DataService', 'DataRetrieverService', 'CurrentStateCriteriaService', 'ScenarioService', 'FeatureToggleService', 'DataRetrieverConstantsService', 'ApplicableSeasonsLoadingService'];
module.exports = MarketAnalysisToolbarController;